const textProps = {
  image: require("assets/img/illustrations/404.svg").default,
  color: "dark",
  error: "404",
  title: "Page not found :(",
  description: "Ooooups! Looks like you got lost.",
};
export default textProps;
